import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchRetailUsers = async () => {
	const response = await cmsClient.get<any>("/homepage/admin/store/user/");
	const data = response.data;
	return Array.isArray(data) ? data : (data.results ?? []);
};

const useRetailUsers = () => {
	return useQuery(["admin-retail-users"], fetchRetailUsers);
};

export default useRetailUsers;
